function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("path", {
  fill: "#0E426B",
  d: "M96.544,3.456v93.088H3.456V3.456H96.544 M100,0H0v100h100V0L100,0z"
}));

var _ref3 =
/*#__PURE__*/
React.createElement("line", {
  fill: "none",
  stroke: "#009AD7",
  strokeWidth: 2.305,
  strokeMiterlimit: 10,
  x1: 28.995,
  y1: 18.073,
  x2: 81.663,
  y2: 18.073
});

var _ref4 =
/*#__PURE__*/
React.createElement("polygon", {
  fill: "#009AD7",
  points: "34.054,24.739 31.222,18.073 34.054,11.411 18.254,18.073 "
});

var _ref5 =
/*#__PURE__*/
React.createElement("line", {
  fill: "none",
  stroke: "#009AD7",
  strokeWidth: 2.305,
  strokeMiterlimit: 10,
  x1: 71.004,
  y1: 81.927,
  x2: 18.254,
  y2: 81.927
});

var _ref6 =
/*#__PURE__*/
React.createElement("polygon", {
  fill: "#009AD7",
  points: "65.947,75.261 68.778,81.927 65.947,88.59 81.747,81.927 "
});

var _ref7 =
/*#__PURE__*/
React.createElement("line", {
  fill: "none",
  stroke: "#009AD7",
  strokeWidth: 2.305,
  strokeMiterlimit: 10,
  x1: 81.663,
  y1: 28.818,
  x2: 81.663,
  y2: 81.927
});

var _ref8 =
/*#__PURE__*/
React.createElement("polygon", {
  fill: "#009AD7",
  points: "74.996,33.874 81.663,31.042 88.328,33.874 81.663,18.073 "
});

var _ref9 =
/*#__PURE__*/
React.createElement("line", {
  fill: "none",
  stroke: "#009AD7",
  strokeWidth: 2.305,
  strokeMiterlimit: 10,
  x1: 18.254,
  y1: 71.182,
  x2: 18.254,
  y2: 18.073
});

var _ref10 =
/*#__PURE__*/
React.createElement("polygon", {
  fill: "#009AD7",
  points: "24.917,66.127 18.254,68.959 11.588,66.127 18.254,81.927 "
});

var SvgPursuits = function SvgPursuits(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "pursuits",
    x: "0px",
    y: "0px",
    width: "100px",
    height: "100px",
    viewBox: "0 0 100 100",
    enableBackground: "new 0 0 100 100",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), React.createElement("title", null, title), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgPursuits, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Pursuits.526430ab.svg";
export { ForwardRef as ReactComponent };